import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'neoris-minidashboard-ppe',
  templateUrl: './minidashboard-ppe.component.html',
  styleUrls: ['./minidashboard-ppe.component.css']
})
export class MinidashboardPpeComponent implements OnInit {

  siteId:string

  constructor() { 
    console.log('minidashboard constructor')
  }

  ngOnInit(): void {
    this.siteId = localStorage.getItem('site')
  }

}
